/* The mockup's `.meter-mini` and `.meter`. */
.mini {
  display: block;
  padding: var(--space-2) 10px;
  border-radius: var(--radius-control);
  color: var(--text-muted);
  font-size: var(--font-size-12);
  text-decoration: none;
}

.mini:hover {
  background: var(--state-hover);
}

.mini:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.text {
  font-variant-numeric: tabular-nums;
}

.meter {
  display: block;
  block-size: 4px;
  margin-block-start: 6px;
  border-radius: 2px;
  background: var(--surface-strong);
  overflow: hidden;
}

.fill {
  display: block;
  inline-size: var(--meter-fill, 0%);
  block-size: 100%;
  border-radius: 2px;
  background: var(--text-muted);
}

.warn .fill {
  background: var(--warning-text);
}

.rail {
  padding: var(--space-2) 6px;
}

.rail .text {
  display: none;
}
